// Synkron förladdningscache för förrenderingen (SSG).
//
// Sidorna laddar sitt innehåll asynkront (import.meta.glob), men renderToString
// är synkron — utan cache skulle varje förrenderad sida bara bli ett tomt skal,
// och det är precis det vi bygger bort (AI-crawlers kör inte JavaScript).
// Förrenderingsskriptet laddar därför datat i förväg och lägger det här; sidornas
// useState-initierare hämtar det synkront vid första render. I webbläsaren är
// cachen tom och sidorna tar sin vanliga asynkrona väg.
const lager = new Map<string, unknown>()

export const forladda = (nyckel: string, varde: unknown): void => {
  lager.set(nyckel, varde)
}

export const hamtaForladdad = <T,>(nyckel: string): T | null => (lager.get(nyckel) as T | undefined) ?? null

export const rensaForladdat = (): void => {
  lager.clear()
}
